import { createFetchContext } from '@/modules/auto-fetch-contex'
import { followUpMessageService } from '@/modules/creator-settings/follow-up-messages/service/follow-up-message-service'

export const {
  useFollowUpMessageService,
  DefaultFollowUpMessageFetchProvider,
  CustomFollowUpMessageFetchProvider,
} = createFetchContext('FollowUpMessageFetch', { followUpMessageService })
